import { configureStore } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import languageReducer from '../features/language/languageSlice';
import userReducer from '../features/user/userSlice';
import viewsReducer from '../features/views/viewsSlice'
import queriesReducer from '../features/queries/queriesSlice';
import tablesReducer from '../features/table/tableSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    language: languageReducer,
    user: userReducer,
    views: viewsReducer,
    queries: queriesReducer,
    tables: tablesReducer
  },
});
